// @ts-nocheck
import { useQuery } from "@tanstack/react-query"
import { FetchUserLists } from "./ApiRoutes"
import MainLoader from "@/utils/Loaders";
import { Ghost } from "lucide-react";
import { mediaTypeIcon } from "@/utils/TextUtils";
import { Input } from "./ui/input";
import { useContext } from "react";
import { UsernameContext } from "@/utils/ProtectedRoutes";

export default function ListBrowser() {

    const activeUser = useContext(UsernameContext).username;
    const profileUsername = window.location.pathname.split('/')[3]; 
    console.log("Profile Username:", profileUsername);
    console.log("Active User:", activeUser);

    const {isPending, isError, data, error, isSuccess } = useQuery({
        queryKey: ['profileList', profileUsername],
        queryFn: () => FetchUserLists(profileUsername),
        enabled: !!profileUsername,
    })
    
    if(isPending){
       return(
        <MainLoader />
        ) 
    }
    if(isError){
        return(
            <div className="flex flex-col h-2/3 gap-2 justify-center items-center text-center text-neutral-500 mt-15 font-semibold">
                <h3 className="text-xl sm:text-2xl"> Something went wrong loading {profileUsername}'s lists :/</h3>
                <p className="text-neutral-600 font-medium">We may be expierencing issues, try again later</p>
                <Ghost className="mt-5 w-10 h-10 text-neutral-700" />
        </div>
        )
    }
    if(isSuccess && data.length >= 1){
        return(
            <main className="flex flex-col w-full items-center h-full px-4">
                <h2 className="text-white text-4xl mt-10 font-bold">{String(activeUser) === profileUsername ? `Your ${data.length} lists` : `${profileUsername}'s ${data.length} lists` }</h2>
                <Input className="sticky top-2 my-5 text-white max-w-2/3 rounded-md z-40" id="item-search" placeholder="oh I know you wanna search something" />
                <section className="flex flex-wrap gap-4 justify-center w-2/3 pb-4">
                    {
                    data.map((item,index)=> {
                        return(
                            <div className="flex flex-col items-center text-center text-white">
                                <section className="flex rounded-t-lg mb-2 w-full justify-center bg-neutral-900 p-1">
                                    <h3 className="text-xs text-wrap break-after-auto"> {item.title}</h3>
                                </section>
                           
                                <article key={item.id} className="relative flex flex-col text-white gap-1">
                                    <div className="flex gap-1 w-full flex-col relative items-center">
                                        <img className="rounded-b-lg h-40 md:h-50 w-fit" src={item.items[0].image_url} alt={item.title} />
                                        <div className="flex absolute inset-0 bg-gradient-to-bl from-black/50 via-transparent to-transparent z-10" />
                                    </div>
                               
                                
                                <div className="absolute right-2 top-2 w-6 h-6 flex z-20">
                                        {mediaTypeIcon(item.list_type)}
                                </div>
                                
                                
                                </article>
                            </div>
                        )
                    })
                }
                </section>
                
            </main>
            
        )
    }
    
    return (<></>
    
    )
}



